import { createContext } from "react";

const ParametersContext = createContext();

export default ParametersContext;
